module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/160802-003-PM-f1776e68f10b75e2bb412feab74ce3a0.JPG";